var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 24c6.075 0 11-4.925 11-11S21.075 2 15 2 4 6.925 4 13c0 1.666.37 3.245 1.033 4.66l-1.276 3.507c-.56 1.54-.84 2.311-.667 2.813.15.437.493.78.93.93.502.173 1.272-.107 2.813-.668l3.507-1.275A10.957 10.957 0 0 0 15 24Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage28);
export default __webpack_public_path__ + "static/media/message_28.87ea61cc.svg";
export { ForwardRef as ReactComponent };